<template>
  <div class="profile">
    <div class="personal_data">个人资料 personal data</div>
    <div class="personal_info">
      <el-form :model="form" ref="form" :rules="rules" label-width="280px">
        <template>
          <el-form-item label="姓名 Name:" prop="realName">
            <el-input v-model="form.realName" :maxlength="100" placeholder="请填写姓名" @change="handleChangeName"></el-input>
          </el-form-item>
          <el-form-item label="手机号 Telephone:">
            <span>{{ form.mobileLike }}</span>
          </el-form-item>
          <el-form-item label="邮箱 Mailboxes:" prop="email">
            <el-input v-model="form.email" :maxlength="100" placeholder="请填写邮箱" @change="handleChangeEmail"></el-input>
          </el-form-item>
          <el-form-item label="身份证/护照号码 ID card/Passport number:">
            <span>{{form.idCardNo}}</span>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <div class="wallet_paid">钱包支付 Wallet paid</div>
    <el-button type="primary" class="modifies" @click="modifiesClick(1)">修改支付密码 Modify payment password</el-button>
    <div class="foget_password" @click="modifiesClick(2)">忘记支付密码 Forgot payment password</div>
    <ModifiesDialog
      v-if="modifiesVisible"
      :visible.sync="modifiesVisible"
      :title="title"
      @dialogCallbackModifies="dialogCallbackModifies"
    ></ModifiesDialog>
    <RetrieveDialog
      v-if="retrieveVisible"
      :visible.sync="retrieveVisible"
      :title="title"
      :infoList="infoList"
      @dialogCallbackRetrieve="dialogCallbackRetrieve"
    ></RetrieveDialog>
  </div>
</template>

<script>
import ModifiesDialog from "./components/ModifiesDialog";
import RetrieveDialog from "./components/RetrieveDialog";
export default {
  name: "order",
  components: { ModifiesDialog, RetrieveDialog },
  data() {
    return {
      rules: {
        realName: [{ required: false, message: "请填写姓名", trigger: "blur" }],
        email: [{ required: false, message: "请填写邮箱", trigger: "blur" }],
      },
      form: {
        realName: "", //姓名
        email: "", //邮箱
        mobileLike: "", //手机号
        idCardNo:"",//身份证号码/护照号码
      },
      infoData: {},
      modifiesVisible: false,
      retrieveVisible: false,
      title: "",
      infoList: {},
    };
  },
  props: {},
  computed: {},
  async mounted() {
    this.getByUid();
  },
  methods: {
    async handleChangeName() {
      const params = {
        realName: this.form.realName
      };
      try {
        await this.$api.updateBaseInfo(params);
        this.$message.success("修改成功");
      } catch (error) {
        console.log(error);
      }
    },
    async handleChangeEmail() {
      const params = {
        email: this.form.email
      };
      try {
        await this.$api.updateBaseInfo(params);
        this.$message.success("修改成功");
      } catch (error) {
        console.log(error);
      }
    },
    async getByUid() {
      let { data } = await this.$api.getByUid();
      this.infoList = data;
      this.form = {
        realName: data.realName,
        email: data.email,
        mobileLike: data.mobileLike,
        idCardNo: data.idcardNo?'已设置':'未设置'
      };
    },
    async modifiesClick(type) {
      if (type == 1) {
        this.title = "修改支付密码 Modify payment password";
        this.modifiesVisible = true;
      } else {
        this.title = "找回支付密码 Retrieve payment password";
        this.retrieveVisible = true;
      }
    },
    async dialogCallbackModifies(val) {
      const params = {
        oldPassword: val.oldPassword,
        password: val.password,
        rePassword: val.rePassword,
      };
      try {
        await this.$api.passwordUpdate(params);
        this.$message.success("修改成功");
        this.modifiesVisible = false;
      } catch (error) {
        console.log(error);
      }
    },
    async dialogCallbackRetrieve(val) {
      let smsCodeFlowNo = localStorage.getItem("smsCodeFlowNo");
      const params = {
        smsCode: val.code,
        smsCodeFlowNo: smsCodeFlowNo,
      };
      try {
        await this.$api.getMoneybagCheckSms(params);
        await this.$api.getMoneybagPasswordRest({
          password: val.fillPassword,
          rePassword: val.surePassword,
          smsCodeFlowNo: smsCodeFlowNo,
        });
        this.$message.success("修改成功");
        this.retrieveVisible = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss">
.profile {
  width: 100%;
  margin-top: 25px;
  border: 1px solid #f0f0f0;
  padding: 30px;
  box-sizing: border-box;
  .personal_data {
    font-size: 16px;
    
    font-weight: bold;
    color: #333333;
    margin-bottom: 54px;
  }
  .personal_info {
    border-bottom: 1px solid #f0f0f0;
    .el-input__inner {
      width: 260px;
    }
  }
  .wallet_paid {
    font-size: 16px;
    
    font-weight: bold;
    color: #333333;
    margin-top: 30px;
  }
  .modifies {
    margin: 21px 0 19px 29px;
    font-size: 14px;
    
    font-weight: 400;
    color: #ffffff;
  }
  .foget_password {
    margin: 21px 0 0 29px;
    font-size: 14px;
    
    font-weight: 400;
    color: #0d4ac8;
    cursor: pointer;
  }
}
</style>
